import { render, staticRenderFns } from "./ShowMobileRecord.vue?vue&type=template&id=6bb56cfe"
import script from "./ShowMobileRecord.vue?vue&type=script&lang=js"
export * from "./ShowMobileRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports